<template>
  <div id="app">
    <a style="position:fixed;z-index:999;bottom:20px;width:48px;height:128px;" target="_blank" href="http://p.qiao.baidu.com/cps/chat?siteId=7696960&userId=18165803">
      <img style="width:100%;height:100%;" src="https://assets.aiyaopai.com/3.0/Group21@3x.png" alt="">
    </a>
    <router-view />
    <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>

<script>
// 引入全局重制css文件
import './assets/style/index.less'

export default {
  name: 'App'
}
</script>

<style scoped lang="less">
#app {
  min-width: 1366px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue